<template>
  <SideBar>
    <template #side-bar-activator>
      <Activator class="self-centered cursor-e-resize" :key="`side_bar_activator>`" @mousedown.native="$router.push({
        name: $route.matched[1].name,
      })" />
    </template>
    <template #content>
      <v-spacer />
      <TSearchField height="30px" width="100%" style="margin:left" class="color-7" border_color="rgb(41,41,41)"
        placeholder="search" :value="workbench_variables.search" @input="workbenchSearch($event.target.value)" @cancel="updateWBLObject({
          path: [
            { workbench_variables: '' }
          ],
          update: {
            search: ''
          }
        })" />
      <v-divider color="white" />
      <v-btn small @click="loadData(''), addLoadAll(`${prefix}waggons`)">
        Load all
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-5" small disabled v-on="on" v-bind="attrs" @click="switchWaggonType('')"
            :class="prefix == '' ? 'grey' : ''">
            <v-icon small>person</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Project.TaktPlan.Sidebar.Train.TooltipOwn') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small disabled v-on="on" v-bind="attrs" @click="switchWaggonType('b')"
            :class="prefix == 'b' ? 'grey' : ''">
            <v-icon small>work</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Project.TaktPlan.Sidebar.Train.TooltipBusiness') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small disabled v-on="on" v-bind="attrs" @click="switchWaggonType('c')"
            :class="prefix == 'c' ? 'grey' : ''">
            <v-icon small>people</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Project.TaktPlan.Sidebar.Train.TooltipCommunity') }}</span>
      </v-tooltip>
      <StandardFlexBox direction="row" width="100%">
        <template v-if="workbench_variables.search === ''">
          <TText
            :value="$store.state.WorkBench.all_loaded.includes(`workpackages`) ? 'All' : 'Last Updated'"
          />
        </template>
        <template v-else>
          <TText
            :value="'Search result{symbol} {searchVal}'"
            :value_props="{symbol: ':', searchVal: workbench_variables.search}"
          />
        </template>
        <v-progress-circular v-if="$store.state.WorkBenchLocal.workbench_variables.loading" class="ml-2" :width="2"
          :size="17" indeterminate color="primary"></v-progress-circular>
      </StandardFlexBox>
      <StandardFlexBox max_height="100px" height="100px">
        <Waggon @click.native="createTWaggon('', [])" :workpackage_count="0" :zoom="2" style="cursor: pointer;">
          <template #content>
            <div class="token-view" style="cursor: pointer; font-size: large;">
              <TText value="Empty" />
            </div>
          </template>
        </Waggon>
        <StandardDataField placeholder="Amount of empty wagons" width="25%" height="26px" text_color="white"
          type="number" :value="amount_of_waggons" @changeValue="amount_of_waggons = $event;" />
      </StandardFlexBox>
      <StandardFlexBox max_height="100px" height="100px" v-if="typeof twaggon_index !== 'undefined' && !isNaN(twaggon_index)">
        <Waggon @click.native="extendWagon()" :workpackage_count="getWorkPackagesForExtend().length" :zoom="2" style="cursor: pointer;">
          <template #content>
            <div class="token-view" style="cursor: pointer; font-size: large;">
              <TText value="Extend" />
            </div>
            <Workpackage
              v-for="(workpackage) in getUObjects({ type: `tworkpackages`, ids: getWorkPackagesForExtend() })"
              :key="`wagworkpackage${workpackage.id}`" :workpackage_count="getWorkPackagesForExtend().length"
              :workpackage="workpackage" :zoom="2" />
          </template>
        </Waggon>
      </StandardFlexBox>
      <StandardFlexBox max_height="calc(100% - 90px - 50px)" height="calc(100% - 90px - 50px)">
        <Waggon v-for="waggon in getWBObjectsFiltered({
          type: `${prefix}waggons`,
          search: {
            token: workbench_variables.search,
            hashtag: workbench_variables.search,
          },
          /* workbench: location === 'WorkBench'?true:false, */
        })" :key="`${prefix}${waggon.id}`" :workpackage_count="waggon[`${prefix}wagworkpackages`].length" :zoom="2"
          @click.native="createTWaggon(waggon.token || '', translateWorkPackages(waggon[`${prefix}wagworkpackages`]))">
          <template #content>
            <div class="token-view" style="cursor: pointer; font-size: large;">
              {{ waggon.token ? waggon.token : '' }}
            </div>
            <Workpackage
              v-for="(workpackage) in getWBObjects({ type: `${prefix}wagworkpackages`, ids: waggon[`${prefix}wagworkpackages`] })"
              :key="`wagworkpackage${workpackage.id}`" :workpackage_count="waggon[`${prefix}wagworkpackages`].length"
              :workpackage="workpackage" :zoom="2" />
          </template>
        </Waggon>
      </StandardFlexBox>
    </template>
  </SideBar>
</template>

<script>
import store from '@/store/index'

import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'

import { AddTWaggonMixin } from '@/mixins/AddTWaggon.mixin.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_index', 'reference'],
  components: {
    SideBar,
    Activator,
  },
  mixins: [
    AddTWaggonMixin
  ],
  data: () => ({
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ])
  },
  methods: {
    ...mapActions('SnackBar', [
      'requestSnackbarCreate'
    ]),
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    ...mapActions('ProjectCalendar', [
      'updateCalenderLookup'
    ]),
    getWorkPackagesForExtend(){
      let twaggon = this.getUObject({ type: 'twaggons', id: this.reference.id });
      return twaggon.tworkpackages;
    },
    extendWagon(){

      let pos = this.twaggon_index + parseInt(1);
      if (!this.reference.before) {
        pos = this.twaggon_index + parseInt(2);
      }
      this.requestSnackbarCreate({
        url: [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.reference.id},
          {extendwp: ''},
          {showWithEntitiesNormalized: ''}
        ],
        u_object: {
          waggon_payload: {position: pos},
          twp_ids: this.getWorkPackagesForExtend()
        },
        reference: this.reference,
        selector: 'reference'
      }).then((payload) => {
        this.createUObject(payload).then(() => {
          this.$router.push({name: 'ProjectTaktPlan'});
          this.updateCalenderLookup(this.project_id)
        })
      })
    }
  },
  created() {
    console.log('ref', this.reference);
    this.loadData(`&limit=8&offset=0`);
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters['Project/isEditMode']) {
      store.dispatch('Project/enterEditMode', { project_id: to.params.project_id });
    }
    next();
    // store.dispatch('Community/requestCommunitySequences')
    // .then(() => {
    //   store.dispatch('Sequence/requestCustomSequences')
    //   .then(() => {
    //     next()
    //   })
    // })
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch('Project/setInsertingTrain', false);
    next();
  },
}
</script>
<style>

</style>
